import React, { Component } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import { getStubGroupList } from "@/fetch/fetchApi";
import PropTypes from "prop-types";
import RefreshGrid from "@/utils/refreshGrid";
// 样式
import "./index.styl";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class WallBoxChoose extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      formConfig: null,
      tableConfig: null,
    };
  }

  componentWillMount = () => {
    this.init();
  };

  init = () => {
    this.setState({
      formConfig: this.setFormConfig(),
      tableConfig: this.setTableConfig(),
    });
  };

  setFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: "电站名称", // '电站名称',
          param: {
            name: "stubGroupName",
            type: "string",
          },
          labelName: "电站名称", // '电站名称:',
          required: false,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              // icon:'search',
              text: "查询", // '查询'
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: true, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "stbuGroupChooseTable",
    };
    return formConfig;
  };

  setTableConfig = () => {
    const tableConfig = {
      tableKey: "stbuGroupChooseTable",
      tableColumns: [
        {
          name: "电站名称", // '电站名称',
          key: "name",
          colType: "tipCol",
          tipNum: 30,
        },
        {
          name: "操作", // '操作',
          key: "action",
          fix: "right",
          colType: "action",
          actionMap: [
            {
              type: "href",
              actionName: "选择", // '设备列表',
              handler: (record) => {
                this.props.setStubGroupInfo(record);
              },
            },
          ],
        },
      ],
      tableChange: () => {},
      tableParam: {
        pagecount: 10,
      },
      dataApi: getStubGroupList,
      autoRefresh: true, // 设置为true 直接加载grid数据
    };
    return tableConfig;
  };

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  fetchApi = (param) => {
    return RefreshGrid(this.context.store, "stbuGroupChooseTable", param);
  };

  render = () => {
    const content = (
      <div className="sc-page-content choose-stub-group-modal">
        <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        <div className="page-panel">
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );
    return content;
  };
}

export default injectIntl(WallBoxChoose);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/wallBox/wallBoxChoose.js